<template>
  <b-row>
    <b-col cols="12" md="3">
      <b-row>
        <b-col cols="8">
          <h3 class="text-primary">Filters</h3>
        </b-col>
        <b-col cols="4">
          <b-button variant="link" @click="onClear" @keydown="onClear"
            >Clear</b-button
          >
        </b-col>
      </b-row>
      <hr class="mt-3" />
      <TagFilter v-model="filters.tag" :filters="filters" />
      <LocationFilter v-model="filters" />
      <MinimumDayRateFilter
        v-model="filters.minimum_day_rate"
        :filters="filters"
      />
      <AvailabilityFilter v-model="filters.availability" :filters="filters" />
    </b-col>
    <b-col cols="12" md="9">
      <b-row align-h="between">
        <b-col cols="auto">
          <CandidateSearchResults :state="candidates" :total="total" />
        </b-col>
        <b-col cols="auto">
          <b-button
            size="sm"
            variant="outline-primary"
            @click="toggleViewMode"
            @keydown="toggleViewMode"
          >
            <i :class="viewMode.icon"> </i>
            {{ viewMode.label }}</b-button
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <hr />
          <CandidatesList
            :candidates="candidates"
            :isListView="isListView"
            @filtered="onFiltered"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import localAsyncAction from '@/mixins/localAsyncAction'
import apiModules from '@/services'
import LocationFilter from './filters/LocationFilter/LocationFilter'
import MinimumDayRateFilter from './filters/MinimumDayRateFilter/MinimumDayRateFilter'
import AvailabilityFilter from './filters/AvailabilityFilter/AvailabilityFilter'
import CandidateSearchResults from './CandidateSearchResults/CandidateSearchResults'
import CandidatesList from './CandidatesList/CandidatesList'
import TagFilter from './filters/TagFilter/TagFilter'
import { isString } from 'lodash/fp'

export default {
  name: 'CandidateSearch',
  components: {
    LocationFilter,
    MinimumDayRateFilter,
    AvailabilityFilter,
    CandidatesList,
    CandidateSearchResults,
    TagFilter
  },
  mixins: [
    localAsyncAction({
      key: 'candidates',
      initialState: [],
      fetcher: {
        methodName: 'searchCandidates',
        handler: apiModules.searchCandidates
      }
    })
  ],
  data() {
    return {
      filteredCandidates: null,
      rightPanelStyle: {
        borderLeft: '1px solid #e5e5e5'
      },
      filters: this.getFiltersOfRouter(this.$route.query),
      mode: localStorage.getItem(`${window.__APP}__view-mode`) || 'list'
    }
  },
  computed: {
    total() {
      return (this.filteredCandidates || this.candidates.data).length
    },
    isListView() {
      return this.mode === 'list'
    },
    viewMode() {
      return this.isListView
        ? {
            icon: 'fa fa-table',
            label: 'Grid View'
          }
        : {
            icon: 'fas fa-bars',
            label: 'List View'
          }
    }
  },
  watch: {
    filters: {
      handler(value) {
        this.onFilter(value)
        this.searchCandidates(value)
      },
      deep: true
    }
  },
  created() {
    this.searchCandidates(this.filters)
  },
  methods: {
    onFiltered(filteredCandidates) {
      this.filteredCandidates = filteredCandidates
    },
    onClear() {
      this.filters = {
        location: [],
        region: [],
        minimum_day_rate: [],
        availability: [],
        tag: []
      }
    },
    parseFilters(filter) {
      let parsedFilter = null
      if (isString(filter)) parsedFilter = [parseInt(filter)]
      else if (filter) parsedFilter = filter.map(item => parseInt(item))
      else parsedFilter = []
      return parsedFilter
    },
    getFiltersOfRouter(query) {
      return {
        location: this.parseFilters(query.location),
        region: this.parseFilters(query.region),
        minimum_day_rate: this.parseFilters(query.minimum_day_rate),
        availability: this.parseFilters(query.availability),
        tag: this.parseFilters(query.tag)
      }
    },
    onFilter(query) {
      this.$router.push({ path: '/', query }).catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      })
    },
    toggleViewMode() {
      this.mode = this.isListView ? 'grid' : 'list'
      localStorage.setItem(`${window.__APP}__view-mode`, this.mode)
    }
  }
}
</script>

<style lang="scss" scoped>
.CandidateSearch__left-panel {
  height: 100%;
}
</style>
